module.exports = __webpack_public_path__ + "img/34A09C_6EE5E3_5CD7D3_4EC9C6-256px.146e8453.png";